module.exports = __webpack_public_path__ + "img/appAsset-http--403-ax.e52ac82d.svg";